<template>
  <v-app v-if="['A','B','N'].find(el=>el==store.state.user.groupe)">
    <v-main>
      <v-container fluid class="pa-6" style="max-width:1200px">
        <!-- En-tête -->
        <v-row class="mb-6">
          <v-col cols="12">
            <v-card  elevation="4">
              <v-card-title class="d-flex align-center">
                <div class="d-flex align-center">
                <v-icon large class="mr-3">mdi-chart-bar</v-icon>
                <div>
                  <h2  class="text-h5 font-weight-bold">{{ title }}</h2>
                  <!-- <h2 v-if="typeStatistics=='getMonthlySales'" class="text-h5 font-weight-bold">Évolution des ventes mensuelles mois {{ getLastWeekAndMonth().moisActuel }} de {{currentYear}} vs {{currentYear-1}}</h2> -->
                  <!-- <div class="text-subtitle-1">Analyse comparative des passages, tickets et leur rapport</div> -->
                </div>
              </div>
                <!-- <v-icon icon="mdi-chart-line" class="mr-3" size="large"></v-icon>
                <h1 class="text-h5 font-weight-bold">Évolution des ventes N vs N-1</h1>
                <v-spacer></v-spacer> -->
                <v-chip variant="outlined" color="white" class="mr-2">
                  <v-icon icon="mdi-calendar" class="mr-1"></v-icon>
                  {{ annee }} vs {{ annee - 1 }}
                </v-chip>
                <v-btn 
                  variant="outlined" 
                  color="white" 
                  @click="exportToExcel"
                  prepend-icon="mdi-microsoft-excel"
                  size="small"
                >
                  Exporter
                </v-btn>
              </v-card-title>
            </v-card>
          </v-col>
        </v-row>

        <!-- Filtres -->
         <!-- <v-card style="margin-bottom:10px ;">
          <v-row  style="margin-top:10px">
            <v-col cols="12" md="3">

                  <v-select
                    v-model="selectedEstablishment"
                    :items="establishments"
                    item-title="text"
                    item-value="value"
                    density="compact"
                    label="Établissement"
                    prepend-icon="mdi-store"
                    clearable
                    @update:modelValue="handleFilterChange"
                    variant="outlined"
                  ></v-select>

            </v-col>
            <v-col cols="12" md="3">

                  <v-text-field
                    v-model="currentYear"
                    label="Année N"
                    type="number"
                    density="compact"
                    prepend-icon="mdi-calendar"
                    @change="handleYearChange"
                    variant="outlined"
                    :min="2000"
                    :max="new Date().getFullYear()"
                  ></v-text-field>

            </v-col>
            <v-col cols="12" md="3">

                  <v-text-field
                    v-model="search"
                    label="Rechercher rayon ou famille..."
                    prepend-icon="mdi-magnify"
                    clearable
                    density="compact"
                    variant="outlined"
                    @input="handleSearch"
                  ></v-text-field>

            </v-col>
          </v-row>
        </v-card> -->
        <!-- Cartes de synthèse -->
        <v-card style="margin-top: -25px;margin-bottom: 10px;">
          <v-card-text class="pa-4" >
            <v-row >
              <v-col cols="12" md="4">
                <v-select
                  v-model="selectedEstablishment"
                  :items="establishments"
                  item-title="text"
                  item-value="value"
                  density="compact"
                  label="Établissement"
                  prepend-icon="mdi-store"
                  clearable
                  @update:modelValue="handleFilterChange"
                  variant="outlined"
                ></v-select>
              </v-col>
              <v-col cols="12" md="3">
                <v-select
                  v-model="typeStatistics"
                  :items="[{code:'getStatsHeb',libelle:'Hebdomadaire'},{code:'getMonthlySales',libelle:'Mensuelle'},]"
                  item-title="libelle"
                  item-value="code"
                  density="compact"
                  label="typeStatistics"
                  prepend-icon="mdi-chart-bar"
                  clearable
                  variant="outlined"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select
                  v-model="annee"
                  :items="Array.from(  { length: currentYear - 2022 + 1 },  (_, i) => 2022 + i)"
                  item-title="text"
                  item-value="value"
                  density="compact"
                  label="Année"
                  clearable
                  variant="outlined"
                ></v-select>
              </v-col>
              <v-col cols="12" md="2">
                <v-select v-if="typeStatistics=='getMonthlySales'"
                  v-model="mois"
                  :items="itemMonths"
                  item-title="libelle"
                  density="compact"
                  label="Mois"
                  clearable
                  variant="outlined"
                ></v-select>
                <v-select v-if="typeStatistics=='getStatsHeb'"
                  v-model="semaine"
                  :items="itemSemaines"
                  item-title="libelle"
                  density="compact"
                  label="Semaines"
                  clearable
                  variant="outlined"
                ></v-select>
              </v-col>
              <v-col cols="12" md="1">
                <v-btn style="margin-top: 5px"
                    density="compact"
                    @click="handleYearChange"
                    aria-label="Refresh"
                    icon="mdi-refresh"
                ></v-btn>
              </v-col>
              
            </v-row>
            <v-row style="margin-top: -30px ;">
              <v-col v-for="card in summaryCards" :key="card.title" cols="12" sm="6" md="3">
                <v-card :color="card.color" dark elevation="3">
                    <div class="d-flex align-center">
                      <v-avatar :color="card.iconColor" class="mr-6" size="40" style="margin-left: 5px;">
                        <v-icon size="28">{{ card.icon }}</v-icon>
                      </v-avatar>
                      <div>
                        <div class="text-subtitle-6">{{ card.title }}</div>
                        <div class="font-weight-bold">{{ card.value }}</div>
                        <div class="text-caption">{{ card.subtitle }}</div>
                      </div>
                    </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <!-- Tableau principal -->
        <v-row>
          <v-col cols="12">
            <v-card elevation="2">
              <v-card-title class="d-flex align-center">
                <v-icon icon="mdi-table" class="mr-2"></v-icon>
                Détail par rayon et famille
                <v-spacer></v-spacer>
                <div class="d-flex align-center">
                  <v-btn v-if="!isExpanded"
                    size="small" 
                    variant="text" 
                    @click="expandAll"
                    prepend-icon="mdi-arrow-expand-all"
                    class="mr-2"
                  >
                    Tout déplier
                  </v-btn>
                  <v-btn v-if="isExpanded"
                    size="small" 
                    variant="text" 
                    @click="collapseAll"
                    prepend-icon="mdi-arrow-collapse-all"
                    class="mr-2"
                  >
                    Tout replier
                  </v-btn>
                  <v-chip size="small" variant="outlined" class="mr-2">
                    {{ filteredGroupedData.length }} rayons
                  </v-chip>
                  <v-chip size="small" variant="outlined">
                    {{ totalFamilies }} familles
                  </v-chip>
                </div>
              </v-card-title>

              <v-data-table
                :headers="headers"
                :items="tableData"
                :search="search"
                :items-per-page="100"
                :expanded="expanded"
                
                item-value="id"
                class="elevation-1"
                hide-default-footer
              >
                <!-- Ligne détaillée pour les rayons -->
                <!--<template #expanded-row="{ columns, item }">
                  <tr v-if="item.type === 'rayon'">
                    <td :colspan="columns.length" class="pa-0">
                      <v-table density="compact" class="famille-details">
                        <thead>
                          <tr>
                            <th class="text-left">Famille</th>
                            <th class="text-right">Qté N</th>
                            <th class="text-right">Qté N-1</th>
                            <th class="text-center">Évolution Qté</th>
                            <th class="text-right">CA N (€)</th>
                            <th class="text-right">CA N-1 (€)</th>
                            <th class="text-center">Évolution CA</th>
                            <th class="text-center">% Évolution</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="famille in getFamillesForRayon(item.rayon)" :key="famille.famille">
                            <td class="pl-10">
                              <v-icon icon="mdi-tag-outline" size="small" class="mr-2"></v-icon>
                              {{ famille.famille }}
                            </td>
                            <td class="text-right">{{ formatNumber(famille.qn) }}</td>
                            <td class="text-right">{{ formatNumber(famille.qn1) }}</td>
                            <td class="text-center">
                              <v-chip :color="getEvolutionColor(famille.evolutionQte)" size="small" density="compact">
                                {{ famille.evolutionQte }}
                              </v-chip>
                            </td>
                            <td class="text-right">{{ formatCurrency(famille.vtn) }}</td>
                            <td class="text-right">{{ formatCurrency(famille.vtn1) }}</td>
                            <td class="text-center">
                              <v-chip :color="getEvolutionColor(famille.evolutionCA)" size="small" density="compact">
                                {{ famille.evolutionCA }}
                              </v-chip>
                            </td>
                            <td class="text-center">
                              <v-chip :color="getEvolutionColor(famille.pctEvolution)" size="small" density="compact">
                                {{ famille.pctEvolution }}
                              </v-chip>
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                    </td>
                  </tr>
                </template>-->

                <!-- Colonne Rayon -->
                <template #[`item.rayon`]="{ item }">
                  <div v-if="item.type === 'rayon'" class="d-flex align-center py-2">
                    <v-icon 
                      :icon="item.isExpanded ? 'mdi-chevron-down' : 'mdi-chevron-right'" 
                      class="mr-2"
                      @click="toggleRayon(item.id)"
                      style="cursor: pointer;"
                    ></v-icon>
                    <!-- <v-avatar color="blue-lighten-5" size="36" class="mr-3">
                      <v-icon color="blue" size="small">mdi-folder</v-icon>
                    </v-avatar> -->
                    <div>
                      <div class="font-weight-bold text-blue-darken-3">{{ item.rayon }}</div>
                      <div class="text-caption text-grey">{{ item.familleCount }} familles</div>
                    </div>
                  </div>
                  <div v-else class="ml-14 d-flex align-center">
                    <v-avatar color="grey-lighten-4" size="28" class="mr-3">
                      <v-icon :color="getEvolutionColor(item.evolutionCA)" size="small">mdi-tag</v-icon>
                    </v-avatar>
                    <span  class="text-grey-darken-2">{{ item.famille }}</span>
                  </div>
                </template>

                <!-- Colonnes avec formatage -->
                <template #[`item.qn`]="{ item }">
                  <span class="font-weight-medium">{{ formatNumber(item.qn) }}</span>
                </template>
                
                <template #[`item.qn1`]="{ item }">
                  {{ formatNumber(item.qn1) }}
                </template>
                
                <template #[`item.vtn`]="{ item }">
                  <span class="font-weight-medium text-blue-darken-3">{{ formatCurrency(item.vtn) }}</span>
                </template>
                
                <template #[`item.vtn1`]="{ item }">
                  {{ formatCurrency(item.vtn1) }}
                </template>

                <!-- Colonnes évolution -->
                <template #[`item.evolutionQte`]="{ item }">
                  <div  class="d-flex justify-center">
                    <v-chip 
                      :color="getEvolutionColor(item.evolutionQte)"
                      size="small"
                      density="comfortable"
                    >
                      <v-icon start :icon="getEvolutionIcon(item.qn, item.qn1)" size="small"></v-icon>
                      {{ item.evolutionQte }}
                    </v-chip>
                  </div>
                </template>

                <template #[`item.evolutionCA`]="{ item }">
                  <div  class="d-flex justify-center">
                    <v-chip 
                      :color="getEvolutionColor(item.evolutionCA)"
                      size="small"
                      density="comfortable"
                    >
                      <v-icon start :icon="getEvolutionIcon(item.vtn, item.vtn1)" size="small"></v-icon>
                      {{ item.evolutionCA }}
                    </v-chip>
                  </div>
                </template>

                <template #[`item.pctEvolution`]="{ item }">
                  <div  class="d-flex justify-center">
                    <v-chip 
                      :color="getEvolutionColor(item.pctEvolution)"
                      size="small"
                      density="comfortable"
                    >
                      {{ item.pctEvolution }}
                    </v-chip>
                  </div>
                </template>
                <template #[`item.globalEvolution`]="{ item }">
                  <div  class="d-flex justify-center">
                    <v-chip 
                      :color="getEvolutionColor(item.globalEvolution)"
                      size="small"
                      density="comfortable"
                    >
                      {{ item.globalEvolution }}
                    </v-chip>
                  </div>
                </template>

                <!-- Colonne actions -->
                <!-- <template #[`item.actions`]="{ item }">
                  <v-btn 
                    v-if="item.type === 'rayon'"
                    icon
                    size="small"
                    variant="text"
                    @click="toggleRayon(item.id)"
                    :color="item.isExpanded ? 'blue' : 'grey'"
                  >
                    <v-icon>{{ item.isExpanded ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                  </v-btn>
                </template> -->
              </v-data-table>
            </v-card>
          </v-col>
        </v-row>

        <!-- Section des graphiques -->
        <v-row class="mt-6">
          <v-col cols="12" md="8">
            <v-card elevation="2">
              <v-card-title class="d-flex align-center">
                <v-icon icon="mdi-chart-bar" class="mr-2"></v-icon>
                Évolution du CA par rayon
              </v-card-title>
              <v-card-text>
                <div class="chart-container" style="height: 300px;">
                  <v-sheet v-if="!chartData.labels.length" class="d-flex align-center justify-center" height="300">
                    <div class="text-center">
                      <v-icon icon="mdi-chart-line" size="64" class="text-grey-lighten-1 mb-4"></v-icon>
                      <div class="text-subtitle-1 text-grey">Aucune donnée à afficher</div>
                    </div>
                  </v-sheet>
                  <div v-else style="position: relative; height: 300px;">
                    <canvas ref="barChartCanvas"></canvas>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="4">
            <v-card elevation="2">
              <v-card-title>
                <v-icon icon="mdi-chart-pie" class="mr-2"></v-icon>
                Répartition du CA
              </v-card-title>
              <v-card-text>
                <div class="chart-container" style="height: 300px;">
                  <v-sheet v-if="!chartData.labels.length" class="d-flex align-center justify-center" height="300">
                    <div class="text-center">
                      <v-icon icon="mdi-pie-chart" size="64" class="text-grey-lighten-1 mb-4"></v-icon>
                      <div class="text-subtitle-1 text-grey">Aucune donnée à afficher</div>
                    </div>
                  </v-sheet>
                  <div v-else style="position: relative; height: 300px;">
                    <canvas ref="pieChartCanvas"></canvas>
                  </div>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <!-- Dialogue de chargement -->
      <v-dialog v-model="loading" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text class="pt-4 text-center">
            <v-progress-circular indeterminate color="white" class="mb-3"></v-progress-circular>
            <div>Chargement des données...</div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-main>
  </v-app>
</template>

<script setup>
import { ref, computed, onMounted, watch, onUpdated } from 'vue'
import Chart from 'chart.js/auto'
import axios from 'axios'
// Références pour les canvas des graphiques
const barChartCanvas = ref(null)
const pieChartCanvas = ref(null)

// Variables pour les graphiques Chart.js
let barChartInstance = null
let pieChartInstance = null

// Données et état
const salesData = ref(    [
      {
        "etablissement": "mn01",
        "rayon": "Femme",
        "famille": "Sacs femme",
        "qn": 150,
        "qn1": 120,
        "vtn": 45000.0,
        "vtn1": 36000.0
      },
      {
        "etablissement": "mn01",
        "rayon": "Femme",
        "famille": "Accessoires",
        "qn": 280,
        "qn1": 250,
        "vtn": 32000.0,
        "vtn1": 30000.0
      }
    ])
const selectedEstablishment = ref('EDISAC MONT NOIR')
let typeStatistics=ref('getStatsHeb')
const currentYear = ref(new Date().getFullYear())
const search = ref('')
const loading = ref(false)
const expanded = ref([])
let title=ref('Chargement des donnés...')
// Données pour les graphiques
const chartData = computed(() => {
  const labels = filteredGroupedData.value.map(r => r.name)
  const dataN = filteredGroupedData.value.map(r => r.totals.vtn / 1000) // Convertir en milliers
  const dataN1 = filteredGroupedData.value.map(r => r.totals.vtn1 / 1000)
  
  return {
    labels,
    dataN,
    dataN1
  }
})

// Headers du tableau

const headers = ref([
  { 
    title: 'Rayon/Famille', 
    key: 'rayon', 
    align: 'start',
    width: '300px',
    sortable: false,
  },
  { 
    title: 'Qté N-1', 
    key: 'qn1', 
    align: 'end',
  },
  { 
    title: 'Qté N', 
    key: 'qn', 
    align: 'end',
  },
  
  { 
    title: 'Évolution Qté', 
    key: 'evolutionQte', 
    align: 'center',
    sortable: false,
  },
  { 
    title: 'CA N-1 (€)', 
    key: 'vtn1', 
    align: 'end',
  },
  { 
    title: 'CA N (€)', 
    key: 'vtn', 
    align: 'end',
  },
  
  { 
    title: 'Évolution CA', 
    key: 'evolutionCA', 
    align: 'center',
    sortable: false,
  },
  { 
    title: '% Évolution', 
    key: 'pctEvolution', 
    align: 'center',
    sortable: false,
  },
  { 
    title: '% Évol Global', 
    key: 'globalEvolution', 
    align: 'center',
    sortable: false,
  },
  { 
    title: '', 
    key: 'actions', 
    align: 'center',
    sortable: false,
    width: '80px'
  },
])

// Données groupées
const groupedData = ref([])

// Données groupées filtrées
const filteredGroupedData = computed(() => {
  if (!search.value) return groupedData.value
  
  
  const searchLower = search.value.toLowerCase()
  return groupedData.value
    .map(rayon => {
      const filteredFamilies = rayon.families.filter(famille =>
        famille.famille.toLowerCase().includes(searchLower) ||
        rayon.name.toLowerCase().includes(searchLower)
      )
      
      if (filteredFamilies.length === 0 && !rayon.name.toLowerCase().includes(searchLower)) {
        return null
      }
      
      // Recalculer les totaux pour les familles filtrées
      const totals = filteredFamilies.reduce((acc, famille) => ({
        qn: Number(acc.qn) + Number(famille.qn),
        qn1: Number(acc.qn1) + Number(famille.qn1),
        vtn: Number(acc.vtn) + Number(famille.vtn),
        vtn1: Number(acc.vtn1) + Number(famille.vtn1)
      }), { qn: 0, qn1: 0, vtn: 0, vtn1: 0 })
      // console.log('totals',totals);
      
      return {
        ...rayon,
        families: filteredFamilies,
        totals
      }
    })
    .filter(rayon => rayon !== null)
})

// Données pour le tableau
const tableData = computed(() => {
  const data = []
  filteredGroupedData.value.forEach(rayon => {
    // Ligne rayon
    data.push({
      id: `rayon-${rayon.name}`,
      type: 'rayon',
      rayon: rayon.name,
      famille: '',
      qn: rayon.totals.qn,
      qn1: rayon.totals.qn1,
      vtn: rayon.totals.vtn,
      vtn1: rayon.totals.vtn1,
      evolutionQte: calculateEvolution(rayon.totals.qn, rayon.totals.qn1) + '%',
      evolutionCA: calculateCurrencyEvolution(rayon.totals.vtn, rayon.totals.vtn1),
      pctEvolution: calculateEvolution(rayon.totals.vtn, rayon.totals.vtn1) + '%',
      globalEvolution:globalEvol.value[rayon.name].evolvtn +'%',
      familleCount: rayon.families.length,
      isExpanded: rayon.isExpanded
    })

    // Lignes familles (si déployé)
    if (rayon.isExpanded) {
      rayon.families.forEach(famille => {
        data.push({
          id: `famille-${rayon.name}-${famille.famille}`,
          type: 'famille',
          rayon: '',
          famille: famille.famille,
          qn: famille.qn,
          qn1: famille.qn1,
          vtn: famille.vtn,
          vtn1: famille.vtn1,
          evolutionQte: calculateEvolution(famille.qn, famille.qn1) + '%',
          evolutionCA: calculateCurrencyEvolution(famille.vtn, famille.vtn1),
          pctEvolution: calculateEvolution(famille.vtn, famille.vtn1) + '%',
          globalEvolution:globalEvol.value[rayon.name][famille.famille].evolvtn + '%',
        })
      })
    }
  })
  // console.log(data);
  
  return data
})
const snackbar = ref({
  show: false,
  message: '',
  color: 'info'
})
let globalEvol=ref()
function transformData(data) {
  const result = {};
  
  // Regrouper les données par rayon et famille
  const groupedData = data.reduce((acc, item) => {
    const { rayon, famille, vtn, vtn1, qn, qn1 } = item;
    
    // Initialiser le rayon
    if (!acc[rayon]) {
      acc[rayon] = {
        totalVtnN: 0,      // N (actuel)
        totalVtnN1: 0,     // N-1 (précédent)
        totalQnN: 0,       // N (actuel)
        totalQnN1: 0,      // N-1 (précédent)
        familles: {}
      };
    }
    
    // Initialiser la famille
    if (!acc[rayon].familles[famille]) {
      acc[rayon].familles[famille] = {
        totalVtnN: 0,
        totalVtnN1: 0,
        totalQnN: 0,
        totalQnN1: 0
      };
    }
    
    // Ajouter les valeurs (N = vtn/qn, N-1 = vtn1/qn1)
    acc[rayon].totalVtnN += vtn || 0;      // N
    acc[rayon].totalVtnN1 += vtn1 || 0;    // N-1
    acc[rayon].totalQnN += qn || 0;        // N
    acc[rayon].totalQnN1 += qn1 || 0;      // N-1
    
    acc[rayon].familles[famille].totalVtnN += vtn || 0;
    acc[rayon].familles[famille].totalVtnN1 += vtn1 || 0;
    acc[rayon].familles[famille].totalQnN += qn || 0;
    acc[rayon].familles[famille].totalQnN1 += qn1 || 0;
    
    return acc;
  }, {});
  
  // Calculer les évolutions et construire le résultat
  Object.entries(groupedData).forEach(([rayon, rayonData]) => {
    // Calculer l'évolution pour le rayon
    const evolvtn = calculateEvolution1(rayonData.totalVtnN1, rayonData.totalVtnN);
    const evolqn = calculateEvolution1(rayonData.totalQnN1, rayonData.totalQnN);
    
    result[rayon] = {
      evolvtn: evolvtn,
      evolqn: evolqn
    };
    
    // Ajouter les familles
    Object.entries(rayonData.familles).forEach(([famille, familleData]) => {
      const famEvolvtn = calculateEvolution1(familleData.totalVtnN1, familleData.totalVtnN);
      const famEvolqn = calculateEvolution1(familleData.totalQnN1, familleData.totalQnN);
      
      result[rayon][famille] = {
        evolvtn: famEvolvtn,
        evolqn: famEvolqn,
        // Optionnel: ajouter les valeurs brutes
        vtnN: Math.round(familleData.totalVtnN * 100) / 100,
        vtnN1: Math.round(familleData.totalVtnN1 * 100) / 100,
        qnN: familleData.totalQnN,
        qnN1: familleData.totalQnN1
      };
    });
    
    // Optionnel: ajouter les totaux du rayon
    result[rayon]._totals = {
      vtnN: Math.round(rayonData.totalVtnN * 100) / 100,
      vtnN1: Math.round(rayonData.totalVtnN1 * 100) / 100,
      qnN: rayonData.totalQnN,
      qnN1: rayonData.totalQnN1
    };
  });
  
  return result;
}

// Fonction pour calculer l'évolution
function calculateEvolution1(ancien, nouveau) {
  if (ancien === 0) {
    return nouveau === 0 ? 0 : 100; // Si ancien = 0 et nouveau > 0 => +100%
  }
  const evolution = ((nouveau - ancien) / ancien) * 100;
  return Math.round(evolution * 100) / 100; // Arrondi à 2 décimales
}
const showSnackbar = (message, color) => {
  snackbar.value = {
    show: true,
    message,
    color
  }
}
// Récupération initiale des données 
const fetchData = async (type,etablissement) => {
  loading.value = true
  let url = `https://my.edisac.com/api/statistics/getStatsHeb`
  let  params={
        annee : annee.value?annee.value:currentYear.value,
        semaine : semaine.value?semaine.value:getLastWeekAndMonth().semainePassee,
        etablissement : etablissement
      }
  if(type=='getMonthlySales'){
    url = `https://my.edisac.com/api/statistics/getMonthlySales`
    params={
        annee : annee.value?annee.value:currentYear.value,
        mois : mois.value.code?mois.value.code:getLastWeekAndMonth().moisActuel,
        etablissement : etablissement
      }
  }
  console.log(params);
  
  try {
    // Simulation d'appel API
    await new Promise(resolve => setTimeout(resolve, 800))
    const config = {
      method: 'get',
      url: url,
      params:params
    }
    
    const response = await axios.request(config)
    
    if (response.data && response.data.data) {
      title.value=
      `Évolution des ventes ${type=='getStatsHeb'?'hebdomadaires':'mensuelles'} de ${ type=='getStatsHeb'?'la semaine '+semaine.value+' de':mois.value.libelle } ${annee.value} vs ${annee.value-1}`
      // currentYear.value=annee.value
    // Données d'exemple étendues
      salesData.value = response.data.data.map(el=>el={...el,qn:Number(el.qn),qn1:Number(el.qn1),vtn:Number(el.vtn),vtn1:Number(el.vtn1)})
    // console.log(salesData.value);
      globalEvol.value=transformData(salesData.value )
      //console.log(globalEvol.value);
      showSnackbar('Données chargées avec succès', 'success')
    //   resetFilters()
      updateGroupedData()
    } else {
      rawData.value = []
      showSnackbar('Aucune donnée disponible pour cet établissement', 'warning')
    }
    // ]
  } finally {
    loading.value = false
    // Donner un peu de temps au DOM pour se mettre à jour avant d'initialiser les graphiques
    setTimeout(initCharts, 100)
  }
}

// Liste des établissements
const establishments = computed(() => {
  const etabs = [...new Set(salesData.value.map(item => item.etablissement))]
  return [
    { text: 'Tous les établissements', value: '' },
    ...etabs.map(etab => ({ text: `${etab.toUpperCase()}`, value: etab }))
  ]
})

// Données filtrées par établissement
const filteredData = computed(() => {

  if (!selectedEstablishment.value) return salesData.value
  return salesData.value.filter(item => item.etablissement === selectedEstablishment.value)
})

// Mise à jour des données groupées
const updateGroupedData = () => {
  const grouped = {}
  
  filteredData.value.forEach(item => {
    if (!grouped[item.rayon]) {
      grouped[item.rayon] = {
        name: item.rayon,
        families: [],
        totals: { qn: 0, qn1: 0, vtn: 0, vtn1: 0 },
        isExpanded: false
      }
    }
    
    grouped[item.rayon].families.push({
      famille: item.famille,
      qn: item.qn,
      qn1: item.qn1,
      vtn: item.vtn,
      vtn1: item.vtn1
    })
    
    grouped[item.rayon].totals.qn += item.qn || 0
    grouped[item.rayon].totals.qn1 += item.qn1 || 0
    grouped[item.rayon].totals.vtn += item.vtn || 0
    grouped[item.rayon].totals.vtn1 += item.vtn1 || 0
  })
  
  groupedData.value = Object.values(grouped)
}

// Cartes de synthèse
const summaryCards = computed(() => {
  const totals = grandTotals.value
  const evolutionQte = calculateEvolution(totals.qn, totals.qn1)
  const evolutionCA = calculateEvolution(totals.vtn, totals.vtn1)
  
  return [
    {
      title: 'CA Total N',
      value: formatCurrency(totals.vtn),
      subtitle: `vs ${formatCurrency(totals.vtn1)}`,
      icon: 'mdi-cash',
      iconColor: 'blue',
      color: 'blue-darken-2'
    },
    {
      title: 'Évolution CA',
      value: `${evolutionCA}%`,
      subtitle: getEvolutionText(evolutionCA),
      icon: parseFloat(evolutionCA) >= 0 ? 'mdi-trending-up' : 'mdi-trending-down',
      iconColor: parseFloat(evolutionCA) >= 0 ? 'green' : 'red',
      color: parseFloat(evolutionCA) >= 0 ? 'green-darken-2' : 'red-darken-2'
    },
    {
      title: 'Quantité Totale',
      value: formatNumber(totals.qn),
      subtitle: `vs ${formatNumber(totals.qn1)}`,
      icon: 'mdi-package-variant',
      iconColor: 'orange',
      color: 'orange-darken-2'
    },
    {
      title: 'Rayons Actifs',
      value: filteredGroupedData.value.length,
      subtitle: `${totalFamilies.value} familles`,
      icon: 'mdi-shape',
      iconColor: 'purple',
      color: 'purple-darken-2'
    }
  ]
})

// Totaux généraux
const grandTotals = computed(() => {
  return {
    qn: filteredData.value.reduce((sum, item) => sum + (item.qn || 0), 0),
    qn1: filteredData.value.reduce((sum, item) => sum + (item.qn1 || 0), 0),
    vtn: filteredData.value.reduce((sum, item) => sum + (item.vtn || 0), 0),
    vtn1: filteredData.value.reduce((sum, item) => sum + (item.vtn1 || 0), 0)
  }
})

// Initialisation des graphiques
const initCharts = () => {
  // Vérifier que les canvas sont disponibles
  if (!barChartCanvas.value || !pieChartCanvas.value) {
    return
  }
  
  // Vérifier qu'il y a des données à afficher
  if (!chartData.value.labels.length) {
    return
  }
  
  // Détruire les instances existantes
  if (barChartInstance) {
    barChartInstance.destroy()
  }
  if (pieChartInstance) {
    pieChartInstance.destroy()
  }
  
  // Créer le graphique en barres
  const barCtx = barChartCanvas.value.getContext('2d')
  barChartInstance = new Chart(barCtx, {
    type: 'bar',
    data: {
      labels: chartData.value.labels,
      datasets: [
        
        {
          label: `CA ${currentYear.value - 1} (k€)`,
          data: chartData.value.dataN1,
          backgroundColor: 'rgba(33, 150, 243, 0.7)',
          borderColor: '#2196F3',
          borderWidth: 1
        },
        {
          label: `CA ${currentYear.value} (k€)`,
          data: chartData.value.dataN,
          
          backgroundColor: 'rgba(255, 152, 0, 0.7)',
          borderColor: '#FF9800',
          borderWidth: 1
        }
      ]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'top',
        },
        tooltip: {
          callbacks: {
            label: (context) => `${context.dataset.label}: ${context.raw.toFixed(1)} k€`
          }
        }
      },
      scales: {
        y: {
          beginAtZero: true,
          ticks: {
            callback: (value) => `${value} k€`
          }
        }
      }
    }
  })
  
  // Créer le graphique circulaire
  const pieCtx = pieChartCanvas.value.getContext('2d')
  
  // Couleurs pour le graphique circulaire
  const pieColors = [
    '#2196F3', '#4CAF50', '#FF9800', '#9C27B0', 
    '#F44336', '#00BCD4', '#8BC34A', '#FF5722',
    '#795548', '#607D8B', '#E91E63', '#3F51B5'
  ]
  
  pieChartInstance = new Chart(pieCtx, {
    type: 'doughnut',
    data: {
      labels: chartData.value.labels,
      datasets: [{
        data: filteredGroupedData.value.map(r => r.totals.vtn),
        backgroundColor: pieColors.slice(0, chartData.value.labels.length),
        borderWidth: 2,
        borderColor: 'white'
      }]
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          position: 'right',
        },
        tooltip: {
          callbacks: {
            label: (context) => {
              const label = context.label || ''
              const value = context.raw || 0
              const total = context.dataset.data.reduce((a, b) => a + b, 0)
              const percentage = Math.round((value / total) * 100)
              return `${label}: ${formatCurrency(value)} (${percentage}%)`
            }
          }
        }
      }
    }
  })
}
let etab=ref()
let type=ref()
import store from '@/store'
import { useRoute, onBeforeRouteUpdate } from 'vue-router'
const route = useRoute()
const loadParams = () => {
      //console.log(route.query);
      if(route.query.etab){
          
          try {
              etab.value=''
              etab.value=route.query.etab.toUpperCase()
              type.value=route.query.type
              // currentUrl.value = window.location.href
              if(route.query.etab){
                  switch (route.query.type) {
                    case 'heb':
                      fetchData('getStatsHeb')
                      selectedEstablishment.value=route.query.etab
                      establishments.value=[]
                      establishments.value.push(route.query.etab)
                      //console.log(establishments.value);
                      //console.log(route);
                      
                      
                      break;
                    case 'mens':
                      fetchData('getMonthlySales')
                      selectedEstablishment.value=route.query.etab
                      typeStatistics.value='getMonthlySales'
                      establishments.value=[]
                      establishments.value.push(route.query.etab)
                      break;
                    default:
                      // chartGrouping.value='etab'
                  }
                  store.commit('addUser',{groupe:'N'})
                  // availableEtablissements.value = etab.value
                  // selectedEtab.value=route.query.etab.toUpperCase()
                  // loadData()
              }
              
          } catch (err) {
              // error.value = err.message
          }
      }
  }
const loadData = () => {
  if (selectedEtab.value) {
    getCrosspoint(selectedEtab.value)
  }
}
// Fonctions utilitaires
const calculateEvolution = (current, previous) => {
  if (!Number(previous) || Number(previous) === 0) return Number(current) > 0 ? '100.0' : '0.0'
  const evolution = ((Number(current) - Number(previous)) / Number(previous)) * 100
  return evolution.toFixed(1)
}
// const calculateEvolutionRayon(rayon){
  
// }
const calculateCurrencyEvolution = (current, previous) => {
  const diff = Number(current) - Number(previous)
  return `${diff >= 0 ? '+' : ''}${formatCurrency(diff)}`
}

const getEvolutionColor = (value) => {
  const num = parseFloat(value)
  if (num > 0) return 'success'
  if (num < 0) return 'error'
  return 'warning'
}

const getEvolutionIcon = (current, previous) => {
  const evolution = calculateEvolution(Number(current), Number(previous))
  if (parseFloat(evolution) > 0) return 'mdi-arrow-up'
  if (parseFloat(evolution) < 0) return 'mdi-arrow-down'
  return 'mdi-minus'
}

const getEvolutionText = (evolution) => {
  const num = parseFloat(evolution)
  if (num > 0) return 'Progression'
  if (num < 0) return 'Régression'
  return 'Stable'
}

const formatNumber = (num) => {
  return new Intl.NumberFormat('fr-FR').format(num || 0)
}

const formatCurrency = (amount) => {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount || 0)
}

// Fonctions d'interaction
let isExpanded=ref(true)
const toggleRayon = (rayonId) => {
  const rayonName = rayonId.replace('rayon-', '')
  const rayon = groupedData.value.find(r => r.name === rayonName)
  if (rayon) {
    rayon.isExpanded = !rayon.isExpanded
    if (rayon.isExpanded) {
      expanded.value.push(rayonId)
    } else {
      expanded.value = expanded.value.filter(id => id !== rayonId)
    }
  }
}

const expandAll = () => {
  groupedData.value.forEach(rayon => {
    rayon.isExpanded = false
  })
  isExpanded.value=false
  expanded.value = groupedData.value.map(r => `rayon-${r.name}`)
}

const collapseAll = () => {
  groupedData.value.forEach(rayon => {
    rayon.isExpanded = false
  })
  isExpanded.value=false
  expanded.value = []
}

const handleFilterChange = () => {
  updateGroupedData()
  // Réinitialiser les graphiques après un court délai pour permettre la mise à jour du DOM
  setTimeout(initCharts, 50)
}

const handleYearChange = () => {
  fetchData(typeStatistics.value)
}

const handleSearch = () => {
  // La recherche est gérée par computed properties, on réinitialise juste les graphiques
  setTimeout(initCharts, 50)
}

const exportToExcel = () => {
  const data = tableData.value.map(item => ({
    Rayon: item.rayon,
    Famille: item.famille,
    'Qté N': item.qn,
    'Qté N-1': item.qn1,
    'Évolution Qté': item.evolutionQte,
    'CA N (€)': item.vtn,
    'CA N-1 (€)': item.vtn1,
    'Évolution CA': item.evolutionCA,
    '% Évolution': item.pctEvolution
  }))
  
  const csvContent = [
    Object.keys(data[0]).join(';'),
    ...data.map(row => Object.values(row).join(';'))
  ].join('\n')
  
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)
  link.setAttribute('href', url)
  link.setAttribute('download', `export-ventes-${currentYear.value}.csv`)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

const getFamillesForRayon = (rayonName) => {
  const rayon = groupedData.value.find(r => r.name === rayonName)
  if (!rayon) return []
  
  return rayon.families.map(famille => ({
    famille: famille.famille,
    qn: famille.qn,
    qn1: famille.qn1,
    vtn: famille.vtn,
    vtn1: famille.vtn1,
    evolutionQte: calculateEvolution(famille.qn, famille.qn1) + '%',
    evolutionCA: calculateCurrencyEvolution(famille.vtn, famille.vtn1),
    pctEvolution: calculateEvolution(famille.vtn, famille.vtn1) + '%'
  }))
}

const totalFamilies = computed(() => {
  // console.log(filteredGroupedData.value);
  
  return filteredGroupedData.value.reduce((sum, rayon) => sum + rayon.families.length, 0)
})
let annee=ref(currentYear.value)
let semaine=ref(getLastWeekAndMonth().semainePassee)
let itemSemaines = ref(Array.from({ length: 52 }, (_, i) => i + 1));
let itemMonths = ref([
    {code:'1',libelle:'Janvier'},
    {code:'2',libelle:'Février'},
    {code:'3',libelle:'Mars'},
    {code:'4',libelle:'Avril'},
    {code:'5',libelle:'Mai'},
    {code:'6',libelle:'Juin'},
    {code:'7',libelle:'Juillet'},
    {code:'8',libelle:'Août'},
    {code:'9',libelle:'Septembre'},
    {code:'10',libelle:'Octobre'},
    {code:'11',libelle:'Novembre'},
    {code:'12',libelle:'Décembre'}
  ])
let mois=ref(
    itemMonths.value.find(el=>el.code==getLastWeekAndMonth().moisActuel)
  )
// Initialisation
function getLastWeekAndMonth() {
    const maintenant = new Date();
    
    // 1. Numéro de la semaine dernière
    const ilYa7Jours = new Date(maintenant);
    ilYa7Jours.setDate(maintenant.getDate() - 7);
    
    // Calcul semaine ISO
    const date = new Date(ilYa7Jours);
    date.setDate(date.getDate() + 4 - (date.getDay() || 7));
    const semainePassee = Math.ceil(((date - new Date(date.getFullYear(), 0, 1)) / 86400000 + 1) / 7);
    
    // 2. Nom du mois dernier
    const moisDernier = new Date(maintenant);
    moisDernier.setMonth(maintenant.getMonth() - 1);
    const nomMois = ['Janvier','Février','Mars','Avril','Mai','Juin',
                     'Juillet','Août','Septembre','Octobre','Novembre','Décembre'][moisDernier.getMonth()];
    
    return {
        semainePassee,
        moisDernier: nomMois,
        moisDernierNum:moisDernier.getMonth()+1,
        moisActuel:(new Date(maintenant)).getMonth()+1,
        anneeDernier:moisDernier.getYear()
    };
}
onBeforeRouteUpdate((to, from) => {
    loadParams()
})
onMounted(() => {
  // fetchData('getStatsHeb')
  loadParams()
})

// Surveiller les changements de données filtrées pour mettre à jour les graphiques
watch(filteredData, () => {
  updateGroupedData()
  setTimeout(initCharts, 100)
})

// Surveiller les changements dans les données groupées
watch(groupedData, () => {
  setTimeout(initCharts, 100)
}, { deep: true })

// Mettre à jour les graphiques lorsque le composant est mis à jour
onUpdated(() => {
  // Vérifier si les graphiques doivent être réinitialisés
  if (chartData.value.labels.length > 0 && (!barChartInstance || !pieChartInstance)) {
    setTimeout(initCharts, 100)
  }
})
</script>

<style scoped>
.famille-details {
  background-color: #f8f9fa;
}

.famille-details th {
  background-color: #e9ecef;
  font-weight: 600;
  color: #495057;
  padding: 8px 16px;
}

.famille-details td {
  padding: 8px 16px;
}

.famille-details tr:hover {
  background-color: #f1f3f5;
}

.v-application .primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.v-card {
  border-radius: 8px;
  overflow: hidden;
}

.v-data-table {
  border-radius: 8px;
  overflow: hidden;
}

.v-chip--size-small {
  height: 24px;
}

.bg-blue-lighten-5 {
  background-color: #e3f2fd;
}

.text-blue-darken-3 {
  color: #1565c0;
}

.text-grey-darken-2 {
  color: #616161;
}

.h-100 {
  height: 100%;
}

.chart-container {
  position: relative;
  width: 100%;
}

/* Styles responsives */
@media (max-width: 960px) {
  .v-card-title {
    flex-direction: column;
    align-items: flex-start !important;
  }
  
  .v-card-title > * {
    margin-bottom: 8px;
  }
  
  .v-card-title .v-spacer {
    display: none;
  }
}
</style>